/* app/js/src/components/common/time-picker/time-picker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
input {
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 12px;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
input::-webkit-input-placeholder {
  color: #c9cdd6;
}
input {
  width: 100%;
  padding: 0 12px 0 12px;
  margin-bottom: 17px;
}
input::-webkit-input-placeholder {
  color: #c9cdd6;
}
input[type=time]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance: none;
  appearance: none;
}
input[type=time]::-webkit-inner-spin-button {
  height: 28px;
  margin-right: -12px;
  opacity: 0.6;
}
input[type=time]::-webkit-datetime-edit-ampm-field {
}
/*# sourceMappingURL=time-picker.component.css.map */
